import React from 'react';

const CenturionFooter = () => (
  <div className="w-full py-3 flex items-center justify-center gap-1.5 opacity-40 hover:opacity-70 transition-opacity">
    <a
      href="https://www.centurionsoftwaresolutions.com"
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center gap-1.5 no-underline"
      data-testid="centurion-footer"
    >
      <span className="text-[10px] text-gray-400">Powered by</span>
      <img src="/centurion-logo.png" alt="Centurion Software Solutions" className="h-4 object-contain" />
    </a>
  </div>
);

export default CenturionFooter;
